import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Renders a simple sequential flow diagram.
 * @param {Object} props
 * @param {Array<string|{label: string, detail?: string}>} props.steps - Steps in order
 * @param {'vertical'|'horizontal'} props.layout - Flow direction
 */
export default function FlowDiagram({ steps = [], layout = 'vertical' }) {
  if (!steps?.length) return null;

  const isHorizontal = layout === 'horizontal';

  return (
    <div
      className={`flow-diagram flow-diagram--${layout}`}
      role="img"
      aria-label={`Diagrama de flujo con ${steps.length} pasos`}
    >
      <div className="flow-diagram__steps">
        {steps.map((step, idx) => {
          const label = typeof step === 'string' ? step : step.label;
          const detail = typeof step === 'object' ? step.detail : null;
          const isLast = idx === steps.length - 1;

          return (
            <div key={idx} className="flow-diagram__item">
              <div className="flow-diagram__step">
                <span className="flow-diagram__number">{idx + 1}</span>
                <div className="flow-diagram__content">
                  <span className="flow-diagram__label">{label}</span>
                  {detail && (
                    <span className="flow-diagram__detail">{detail}</span>
                  )}
                </div>
              </div>
              {!isLast && (
                <div className="flow-diagram__arrow" aria-hidden>
                  {isHorizontal ? (
                    <ChevronRight size={20} />
                  ) : (
                    <ChevronDown size={20} />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
